/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { arrayToObject } from './array.js';
import { setPropStyles } from './string.js';
export function getElementStorybookArgTypes(tagName, customElementsMetadata) {
    const meta = arrayToObject(customElementsMetadata.tags, 'name')[tagName];
    return { ...getPropOptionsStorybookArgs(meta), ...getCustomPropsStorybookArgs(meta), ...getSlotStorybookArgs(meta) };
}
export function getElementStorybookArgs(args) {
    return { ...args, style: setPropStyles(args) };
}
function getCustomPropsStorybookArgs(customElementMetadata) {
    return customElementMetadata.cssProperties?.reduce((obj, prop) => {
        const type = prop?.name?.includes('color') || prop?.name?.endsWith('background') ? 'color' : 'text';
        return { ...obj, [prop.name]: { control: { type } } };
    }, {});
}
function getPropOptionsStorybookArgs(customElementMetadata) {
    return customElementMetadata.properties
        ?.filter((prop) => prop?.type?.includes(' | '))
        .reduce((obj, prop) => {
        const options = prop.type.split('|').map(p => p.replace(/"/g, '').replace(/\s/g, ''));
        return {
            ...obj,
            [prop.name]: {
                control: { type: 'select', options },
                defaultValue: options[0],
            },
        };
    }, {});
}
function getSlotStorybookArgs(customElementMetadata) {
    return customElementMetadata.slots?.reduce((obj, prop) => {
        return { ...obj, [prop.name]: { control: { type: 'text' }, defaultValue: `${prop.name}` } };
    }, {});
}
